import React, { FC, useEffect } from 'react';
import moment from 'moment/moment';
import { FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, UseFormOptions } from 'react-hook-form';

import { fc } from 'i18n';
import { IIssuePayload, ITepDevice } from 'types/tep';
import { close as closeSign } from 'assets/icons';
import Button from 'core/react/general/form/Button';
import { Preloader } from 'components/atoms/preloader';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { issueModalSelector } from 'core/redux/selectors/tep';
import { ModalWrapper } from 'components/molecules/modal-wrapper';
import { useIssueColumns } from 'hooks/tep/leases/useIssueColumns';
import { InfoTable } from 'components/organisms/tables/info-table';
import { actions as leasesActions } from 'core/redux/api/veta/tep/leases';

import styles from './styles.module.css';

const FORM_OPTIONS: UseFormOptions<{ device: ITepDevice }> = {
  mode: 'onChange',
};

export const IssueModal: FC = () => {
  const dispatch = useDispatch();

  const { isLoading, error, selected, leases } = useSelector(issueModalSelector);

  const formMethods = useForm<{ device: ITepDevice }>(FORM_OPTIONS);

  const columns = useIssueColumns();

  const { setValue } = formMethods;

  const setFormValues = (device: ITepDevice) => {
    setValue('device', device);
  };

  const close = () => dispatch(leasesActions.close());

  const issueLease = () => {
    const issued: Record<string, IIssuePayload> = {};

    leases.forEach((entryPass) => {
      const { id, lease } = entryPass;
      const { company, email, plateNumber, startOn, endOn } = lease;
      const start = moment(startOn).format('YYYY-MM-DD');
      const end = moment(endOn).format('YYYY-MM-DD');

      issued[id] = { company, email, plateNumber, startOn: start, endOn: end };
    });

    dispatch(leasesActions.issue.request({ data: { leases: issued } }));
  };

  useEffect(() => {
    if (selected) {
      setFormValues(selected);
    }
  }, [selected]);

  return (
    <ModalWrapper>
      <FormProvider {...formMethods}>
        <form className={styles.content}>
          <span className={styles.close} onClick={close}>
            <SvgWrapper width={26} height={26} details={closeSign} />
          </span>
          <div className={styles.title}>{fc('issuance overview')}</div>
          {/*@ts-ignore*/}
          <InfoTable isLoading={false} height={240} columns={columns} data={leases} />
          <div className={styles.totalCount}>{`Total No. Of Entries : ${leases.length}`}</div>
          <div className={styles.footer}>
            <div className={styles.error}>{error || ''}</div>
            <Button onClick={issueLease} className={`${styles.submit} active`} type="button">
              <span>{fc('issue')}</span>
            </Button>
          </div>
        </form>
        {isLoading && <Preloader />}
      </FormProvider>
    </ModalWrapper>
  );
};
